import { render, staticRenderFns } from "./ReferenceGenomes.vue?vue&type=template&id=24094875&"
import script from "./ReferenceGenomes.vue?vue&type=script&lang=js&"
export * from "./ReferenceGenomes.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceGenomes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports